import { FormikProps } from "formik";
import { isNil } from "lodash";
import { trackerApi } from "../../core/api/TrackerApi";
import { useMutationUpdate, useQueryArray, useQueryObjectForm } from "../../core/components/helpers/queryHelper";
import { CheckDto } from "./CheckDataType";



const updateCheck = async (values: CheckDto) => {
    await trackerApi.callServicePatch("/oot/checks/" + values.id, values);
}

export const useMutationUpdateCheck = (formikRef: React.RefObject<FormikProps<CheckDto>>) => {

    let mutation = useMutationUpdate<CheckDto>(formikRef, updateCheck, ["/oot/checks"], "Update Check")

    return mutation;
}

const fetchCheckById = async (id: number) => {
    let data: CheckDto = await trackerApi.callServiceGetById("/oot/checks", id);

    return data;
}


export const useQueryCheckById = (id: number) => {
    let query = useQueryObjectForm<CheckDto>(["/oot/checks", id], () => fetchCheckById(id), "")

    return query;
}

const fetchCheck = async () => {



    let data: Array<CheckDto> = await trackerApi.callServiceGet("/oot/checks");

    return data;
}


export const useQueryChecks = () => {

    let query = useQueryArray<CheckDto>(["/oot/checks"], () => fetchCheck(), "Get Checks")

    return query;
}

const fetchCheckByLocation = async (locationId?: number) => {

    if (isNil(locationId))
        return [];


    let data: Array<CheckDto> = await trackerApi.callServiceGet("/oot/checks/by-location/" + locationId);

    return data;
}


export const useQueryChecksByLocation = (locationId?: number) => {

    let query = useQueryArray<CheckDto>(["/oot/checks/by-location", locationId], () => fetchCheckByLocation(locationId), "Get Checks")

    return query;
}